module.exports = __webpack_public_path__ + "media/images/user_default-daa43922b043c81b8e5a2d816ff225d7.png";